import '@fontsource/fredoka/latin-400.css';
import '@fontsource/fredoka/latin-500.css';
import '@fontsource/fredoka/latin-600.css';
import '@fontsource/fredoka/latin-700.css';
import '@fontsource/nunito-sans/latin-400.css';
import '@fontsource/nunito-sans/latin-600.css';
import '@fontsource/nunito-sans/latin-700.css';
import '@fontsource/nunito-sans/latin-800.css';
import './styles/tokens.css';
import './styles/a11y.css';
import './styles/sheets.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { watchClientErrors } from './lib/clientErrors.js';
import { installSheetDrag } from './lib/sheetDrag.js';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element was not found.');
}

installSheetDrag();
watchClientErrors();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
